module.exports = __webpack_public_path__ + "static/isoservers-6ab35bcfae12268f16fb48b502b969a4.png";